import { useEffect, useState } from "react";
import moment from 'moment';
import 'moment/locale/es';
import axios from 'axios';
import './Slider.css';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const API_URL = 'https://radioital.com/api/public/api/eventos';

const Slider = () => {
  const [events, setEvents] = useState(null);
  //shuffle(slides);
  
  useEffect(() => {
    axios.get(API_URL, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then((res) => setEvents(res.data.data));
  }, []);
  useEffect(() => {
    if(events){
      new Swiper('.sliderE', {
        autoplay:{
            delay: 7500,
            pauseOnMouseEnter: true,
            disableOnInteraction: true,
        },
        modules:[Autoplay, Pagination, Navigation, Scrollbar],
        direction: 'horizontal',
        loop: true,
        spaceBetween: 10,
        slidesPerView: 1,
        breakpoints: {
            // when window width is >= 768px
            768: {
              slidesPerView: 1,
            }
        },
        scrollbar: {
            dragClass: 'swiper-scrollbar-drag',
            el: '.ses',
            draggable: true,
        },
        navigation: {
          nextEl: '.sen',
          prevEl: '.sep',
        },
      });
    }
  });
  if(events){
    return (
      <div className="sliderE swiper">
        <div className="swiper-wrapper">
          {events.map((sld, indexq) => (
              <div className="swiper-slide" key={indexq}>
                  <h3>{sld.ttlo_evnt}</h3>
                  <div className='content-slider'>
                  <img alt={sld.ttlo_evnt} src={'/events/' + sld.imgn_evnt} />
                  </div>
                  <div className='event-data'>
                      <span className='title'>Fecha</span>
                      <span className='body'>{moment(sld.fcha_evnt).format('dddd,Do MMMM YYYY') + " | " + ( sld.hraini_evnt != "00:00:00" ? moment(sld.hraini_evnt, "h:mm").format('h:mm A') : '' )}</span>
                      <br></br>
                      <span className='title'>Lugar</span>
                      <span className='body'>{sld.lgar_evnt}</span>
                  </div>
              </div>
          ))}
        </div>
        <div className="swiper-button-prev sep"></div>
        <div className="swiper-button-next sen"></div>
        <div className="swiper-scrollbar ses"></div>
      </div>
    );
  }
};

export default Slider;
